import React from 'react';

const services = [
  { 
    title: 'Agentiske AI-systemer', 
    desc: 'Ikke chatboter. Ekte AI-agenter som forsker, beslutter og utfører—med menneskelig tilsyn når det trengs.'
  },
  { 
    title: 'AI-strategi', 
    desc: 'Dropp 200-siders rapporten. Få et veikart som er i produksjon innen 90 dager.'
  },
  { 
    title: 'Prosessautomatisering', 
    desc: 'Dine manuelle prosesser, borte. Arbeidsflyter som håndterer 10x volum uten 10x ansatte.'
  },
  { 
    title: 'Dataintelligens', 
    desc: 'Pipelines, vektorlagre, sanntidsanalyse. Infrastrukturen din AI faktisk trenger.'
  },
  { 
    title: 'Produksjonssystemer', 
    desc: 'Produksjonsgrad pålitelighet. Vi bygger systemer som fungerer klokken 3 om natten når ingen ser.'
  },
];

export default function Services() {
  return (
    <div className="win95-help-content">
      {/* Toolbar */}
      <div className="win95-help-toolbar">
        <button className="win95-toolbar-btn">Innhold</button>
        <button className="win95-toolbar-btn">Indeks</button>
        <button className="win95-toolbar-btn">Tilbake</button>
        <button className="win95-toolbar-btn disabled">Skriv ut</button>
      </div>

      {/* Help Content */}
      <div className="win95-help-body">
        <div className="win95-help-title">
          <span className="win95-help-icon">📋</span>
          Hva Vi Bygger
        </div>

        <div className="win95-help-intro">
          <p><strong>AI som kjører. Ikke AI som demonstrerer.</strong></p>
          <p>De fleste AI-prosjekter dør i pilot. Våre leveres til produksjon—og blir der.</p>
        </div>

        <div className="win95-help-section">
          <div className="win95-section-title">► Tjenesteoversikt</div>
          
          <div className="win95-help-list">
            {services.map((s, i) => (
              <div key={i} className="win95-help-item" data-testid={`service-item-${i}`}>
                <span className="win95-bullet">•</span>
                <div className="win95-item-content">
                  <span className="win95-item-title">{s.title}</span>
                  <p className="win95-item-desc">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="win95-help-footer">
          <hr className="win95-hr" />
          <p>For mer informasjon, dobbeltklikk på <strong>Kontakt</strong>-ikonet på skrivebordet.</p>
        </div>
      </div>
    </div>
  );
}
